export default function Row({ className, children, ...props }) {
  const localClassName = ["row", ...className.split(" ")].join(" ");
  return (
    <div className={localClassName} {...props}>
      {children}
    </div>
  );
}

Row.defaultProps = {
  className: "",
};
